export default __webpack_public_path__ + "atomic/_patterns/02-molecules/media-item/_media-item.twig";